import { MenuItem } from "../../../../store/menuSlice";
import { AgentIcon } from "../../../Icons/svgComponents/AgentIcon";
import { HealthIcon } from "../../../Icons/svgComponents/HealthIcon";
import { UserIcon } from "../../../Icons/svgComponents/UserIcon";
import { AuditContextIcon } from "../../../Icons/svgComponents/AuditContextIcon";
import { AuditTrailIcon } from "../../../Icons/svgComponents/AuditTrailIcon";
import { CloudAccountIcon } from "../../../Icons/svgComponents/CloudAccountIcon";
import { DomainIcon } from "../../../Icons/svgComponents/DomainIcon";
import { GroupIcon } from "../../../Icons/svgComponents/GroupIcon";
import { IdentityIcon } from "../../../Icons/svgComponents/IdentityIcon";
import { ImageIcon } from "../../../Icons/svgComponents/ImageIcon";
import { KubernetesIcon } from "../../../Icons/svgComponents/KubernetesIcon";
import { LocationIcon } from "../../../Icons/svgComponents/LocationIcon";
import { PolicyIcon } from "../../../Icons/svgComponents/PolicyIcon";
import { QuotaIcon } from "../../../Icons/svgComponents/QuotaIcon";
import { SecretIcon } from "../../../Icons/svgComponents/SecretIcon";
import { ServiceAccountIcon } from "../../../Icons/svgComponents/ServiceAccountIcon";
import { VolumeSetIcon } from "../../../Icons/svgComponents/VolumeSetIcon";
import { WorkloadIcon } from "../../../Icons/svgComponents/WorkloadIcon";
import { UsageIcon } from "../../../Icons/svgComponents/UsageIcon";
import { LogIcon } from "../../../Icons/svgComponents/LogIcon";
import { MetricsIcon } from "../../../Icons/svgComponents/MetricsIcon";
import { OrgIcon } from "../../../Icons/svgComponents/OrgIcon";
import { GvcIcon } from "../../../Icons/svgComponents/GvcIcon";
import { RenderSvgIcon } from "../../../Icons/svgComponents/RenderSvgIcon";
import { DollarOutlined, UserOutlined } from "@ant-design/icons";
import { Package, Play } from "react-feather";
import { gvcScopedKinds } from "../../../../services/utils";

export function getMenuItems(org: string, gvc?: string): MenuItem[] {
  const menuItems: MenuItem[] = [
    {
      id: "org",
      label: `Org: ${org}`,
      url: `/console/org/${org}`,
      icon: <OrgIcon />,
      category: "resources",
      subCategory: "Org",
      customIsActive: (pathname) => {
        return (
          pathname.endsWith(`/console/org/${org}`) ||
          pathname.startsWith(`/console/org/${org}/summary`) ||
          pathname.startsWith(`/console/org/${org}/session-timeout`) ||
          pathname.startsWith(`/console/org/${org}/auth-config`) ||
          pathname.startsWith(`/console/org/${org}/external-logs`) ||
          pathname.startsWith(`/console/org/${org}/tracing`) ||
          pathname.startsWith(`/console/org/${org}/observability`) ||
          pathname.startsWith(`/console/org/${org}/threat-detection`) ||
          pathname.startsWith(`/console/org/${org}/tags`) ||
          pathname.startsWith(`/console/org/${org}/event`) ||
          pathname.startsWith(`/console/org/${org}/audit-trail`) ||
          pathname.startsWith(`/console/org/${org}/access-report`)
        );
      },
    },
    {
      id: "health",
      label: "Health",
      url: `/console/org/${org}/health`,
      icon: <HealthIcon />,
      category: "health",
      canFavorite: false,
    },
    {
      id: "agents",
      label: "Agents",
      url: `/console/org/${org}/agent`,
      icon: <AgentIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "audit-contexts",
      label: "Audit Contexts",
      url: `/console/org/${org}/auditctx`,
      icon: <AuditContextIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "cloud-accounts",
      label: "Cloud Accounts",
      url: `/console/org/${org}/cloudaccount`,
      icon: <CloudAccountIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "domains",
      label: "Domains",
      url: `/console/org/${org}/domain`,
      icon: <DomainIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "groups",
      label: "Groups",
      url: `/console/org/${org}/group`,
      icon: <GroupIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "gvcs",
      label: "GVCs",
      url: `/console/org/${org}/gvc`,
      icon: <GvcIcon />,
      category: "resources",
      subCategory: "Org",
      customIsActive: (pathname) => {
        if (gvc && pathname.startsWith(`/console/org/${org}/gvc/${gvc}/`)) {
          return false;
        }
        for (const gvcScopedKind of gvcScopedKinds) {
          if (pathname.includes(`/${gvcScopedKind}`)) {
            return false;
          }
        }
        if (pathname.startsWith(`/console/org/${org}/gvc`)) {
          return true;
        }
        return false;
      },
    },
  ];

  if (gvc) {
    menuItems.push({
      id: "gvc",
      label: `GVC: ${gvc}`,
      url: `/console/org/${org}/gvc/${gvc}`,
      icon: <GvcIcon />,
      category: "resources",
      subCategory: "GVC",
      customIsActive: (pathname) => {
        return (
          pathname.endsWith(`/console/org/${org}/gvc/${gvc}`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/summary`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/endpoint-naming-format`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/locations`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/location-query`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/pull-secret`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/environment-variables`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/load-balancer`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/keda`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/tracing`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/sidecar-envoy`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/tags`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/event`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/audit-trail`) ||
          pathname.startsWith(`/console/org/${org}/gvc/${gvc}/access-report`)
        );
      },
    });
  }

  menuItems.push(
    {
      id: "identities",
      label: "Identities",
      url: `/console/org/${org}/identity`,
      icon: <IdentityIcon />,
      category: "resources",
      subCategory: "GVC",
      customIsActive: (pathname) => {
        let res = false;
        if (pathname.startsWith(`/console/org/${org}/identity`)) {
          res = true;
        }
        if (pathname.startsWith(`/console/org/${org}/gvc/`) && pathname.includes(`/identity/`)) {
          res = true;
        }
        return res;
      },
    },
    {
      id: "images",
      label: "Images",
      url: `/console/org/${org}/repository`,
      icon: <ImageIcon />,
      category: "resources",
      subCategory: "Org",
      customIsActive: (pathname) => {
        return (
          pathname.startsWith(`/console/org/${org}/repository`) || pathname.startsWith(`/console/org/${org}/image`)
        );
      },
    },
    {
      id: "ip-sets",
      label: "IP Sets",
      url: `/console/org/${org}/ipset`,
      icon: <RenderSvgIcon icon="ipset" />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "kubernetes",
      label: "Kubernetes",
      url: `/console/org/${org}/mk8s`,
      icon: <KubernetesIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "locations",
      label: "Locations",
      url: `/console/org/${org}/location`,
      icon: <LocationIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "policies",
      label: "Policies",
      url: `/console/org/${org}/policy`,
      icon: <PolicyIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "quotas",
      label: "Quotas",
      url: `/console/org/${org}/quota`,
      icon: <QuotaIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "secrets",
      label: "Secrets",
      url: `/console/org/${org}/secret`,
      icon: <SecretIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "service-accounts",
      label: "Service Accounts",
      url: `/console/org/${org}/serviceaccount`,
      icon: <ServiceAccountIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "users",
      label: "Users",
      url: `/console/org/${org}/user`,
      icon: <UserIcon />,
      category: "resources",
      subCategory: "Org",
    },
    {
      id: "volume-sets",
      label: "Volume Sets",
      url: `/console/org/${org}/volumeset`,
      icon: <VolumeSetIcon />,
      category: "resources",
      subCategory: "GVC",
      customIsActive: (pathname) => {
        let res = false;
        if (pathname.startsWith(`/console/org/${org}/volumeset`)) {
          res = true;
        }
        if (pathname.startsWith(`/console/org/${org}/gvc/`) && pathname.includes(`/volumeset/`)) {
          res = true;
        }
        return res;
      },
    },
    {
      id: "workloads",
      label: "Workloads",
      url: `/console/org/${org}/workload`,
      icon: <WorkloadIcon />,
      category: "resources",
      subCategory: "GVC",
      customIsActive: (pathname) => {
        let res = false;
        if (pathname.startsWith(`/console/org/${org}/workload`)) {
          res = true;
        }
        if (pathname.startsWith(`/console/org/${org}/gvc/`) && pathname.includes(`/workload/`)) {
          res = true;
        }
        return res;
      },
    },
    {
      id: "audit-trail",
      label: "Audit Trail",
      url: `/console/org/${org}/audittrail`,
      icon: <AuditTrailIcon />,
      category: "analyze",
    },
    {
      id: "cost-usage",
      label: "Cost & Usage",
      url: `/console/org/${org}/usage`,
      icon: <UsageIcon />,
      category: "analyze",
    },
    {
      id: "job-executions",
      label: "Job Executions",
      url: `/console/org/${org}/job-executions`,
      icon: <Play className="without-fill" />,
      category: "analyze",
    },
    {
      id: "logs",
      label: "Logs",
      url: `/console/org/${org}/logs`,
      icon: <LogIcon />,
      category: "analyze",
    },
    // {
    //   id: "metrics",
    //   label: "Metrics",
    //   url: "#",
    //   icon: <MetricsIcon />,
    //   category: "analyze",
    // },
    {
      id: "metrics",
      label: "Metrics",
      url: `/console/org/${org}/metrics`,
      icon: <MetricsIcon />,
      category: "analyze",
    },
    {
      id: "template-catalog",
      label: "Catalog",
      url: `/console/org/${org}/marketplace/template`,
      icon: <RenderSvgIcon icon="catalog" />,
      category: "templates",
    },
    {
      id: "template-releases",
      label: "Releases",
      url: `/console/org/${org}/marketplace/release`,
      icon: <Package className="without-fill" />,
      category: "templates",
    },
    {
      id: "helm-releases",
      label: "Helm Releases",
      url: `/console/org/${org}/helmrelease`,
      icon: <Package className="without-fill" />,
      category: "templates",
    },
    {
      id: "orgs",
      label: "Orgs",
      url: "/home/org",
      icon: <RenderSvgIcon icon="org" />,
      category: "management",
    },
    {
      id: "billing-accounts",
      label: "Billing Accounts",
      url: "/home/account",
      icon: <DollarOutlined style={{ transform: "translateY(-2px)" }} />,
      category: "management",
    },
    {
      id: "my-profile",
      label: "My User Profile",
      url: "/home/profile",
      icon: <UserOutlined style={{ transform: "translateY(-2px)" }} />,
      category: "management",
    },
  );

  return menuItems;
}

export const consoleMenuCategories = [
  { id: "health", label: "", expandable: false },
  { id: "resources", label: "Resources", expandable: true },
  { id: "analyze", label: "Analyze", expandable: true },
  { id: "templates", label: "Templates", expandable: true },
  { id: "management", label: "Management", expandable: true },
];

export const homeMenuCategories = [{ id: "management", label: "Management", expandable: false }];
